import FootballMatchStatusHelper from "./FootballMatchStatusHelper";
import MatchStatus from "../Models/Match/Status/MatchStatus";
import { FootballMatchStatusEnum } from "../Enums/FootballMatchStatusEnum";

export default class FootballHelpers {
  private matchStatusHelper: FootballMatchStatusHelper;

  constructor() {
    this.matchStatusHelper = new FootballMatchStatusHelper();
  }

  /**
   * Maps a MatchStatus to the corresponding FootballMatchEventStatus
   * @param matchStatus The match status to map
   * @returns The corresponding FootballMatchStatusEnum
   */
  public getMatchStatusEnum(matchStatus: MatchStatus): FootballMatchStatusEnum {
    return this.matchStatusHelper.getMatchEventStatus(matchStatus);
  }

  /**
   * Checks if a match is upcoming based on its status
   * @param matchStatus The match status to check
   * @returns True if the match is upcoming, false otherwise
   */
  public isMatchUpcoming(matchStatus: MatchStatus): boolean {
    return this.matchStatusHelper.isUpcoming(matchStatus);
  }

  /**
   * Checks if a match is live based on its status
   * @param matchStatus The match status to check
   * @returns True if the match is live, false otherwise
   */
  public isMatchLive(matchStatus: MatchStatus): boolean {
    return this.matchStatusHelper.isLive(matchStatus);
  }

  /**
   * Checks if a match is finished based on its status
   * @param matchStatus The match status to check
   * @returns True if the match is finished, false otherwise
   */
  public isMatchFinished(matchStatus: MatchStatus): boolean {
    return this.matchStatusHelper.isFinished(matchStatus);
  }
}
